import axios from 'axios'
import {
  getAssetMetadataUrl,
  getCaseAssetsUrl,
  getStatefulPropertiesUrl,
  WITH_CREDENTIALS_CONFIG,
} from './constants'

export const getCaseAssets = (caseId: number) =>
  axios.get(getCaseAssetsUrl(caseId), WITH_CREDENTIALS_CONFIG)

export const getAssetMetadata = (caseId: number, assetId: number) =>
  axios.get(getAssetMetadataUrl(caseId, assetId), WITH_CREDENTIALS_CONFIG)

export const getStatefulProperties = (
  caseId: number,
  assetId: number,
  assetInputId: number
) =>
  axios.get(
    getStatefulPropertiesUrl(caseId, assetId, assetInputId),
    WITH_CREDENTIALS_CONFIG
  )
